import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import LoaderComponent from "../../Components/common/LoaderComponent";
import OrganisationGroupsDashboard from "../pages/Dashboard";
import OrganisationGroupsMembers from "../pages/Members";
import OrganisationGroupsStaff from "../pages/Staff";
import OrganisationGroupsMemberOrganisations from "../pages/MemberOrganisations";
import OrganisationGroupsStaffDetail from "../pages/StaffDetail";
import OrganisationGroupsSettings from "../pages/Settings";
import OrganisationGroupsSchoolDetails from "../pages/SchoolDetails";
import OrganisationGroupsHelpAndSupport from "../pages/HelpAndSupport";
import OrganisationGroupsReportAnIssue from "../pages/ReportAnIssue";
import OrganisationGroupsUpdatePassword from "../pages/UpdatePassword";
import OrganisationPrivateRoutesSuspense from "../layout/OrganisationPrivateRoutesSuspense";
import {
  getAuthenticatedHomeRoute,
  getAuthToken,
  hasAuthenticatedUserData,
} from "../../Util/authRedirect";
import { getOrganisationRoleAccess, isOrganisationGroupUser } from "../utils/roleAccess";
import FAQs from "../../pages/FAQs";

export default function OrganisationRoutes() {
  const rehydrated = useSelector((state) => state?.authSlice?._persist?.rehydrated);
  const userData = useSelector((state) => state?.authSlice.userData?.payload);
  const authToken = getAuthToken(userData);
  const access = getOrganisationRoleAccess(userData);

  if (!rehydrated) return <LoaderComponent />;

  if (!authToken) return <Navigate to="/" replace />;

  if (!hasAuthenticatedUserData(userData)) return <LoaderComponent />;

  if (!isOrganisationGroupUser(userData)) {
    return <Navigate to={getAuthenticatedHomeRoute(userData)} replace />;
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to="dashboard" replace />} />
      <Route element={<OrganisationPrivateRoutesSuspense />}>
        <Route path="dashboard" element={<OrganisationGroupsDashboard />} />
        <Route
          path="staff"
          element={
            access.canViewStaff ? (
              <OrganisationGroupsStaff />
            ) : (
              <Navigate to="/organisations/dashboard" replace />
            )
          }
        />
        <Route
          path="members"
          element={
            access.canViewMemberOrganisations ? (
              <OrganisationGroupsMembers />
            ) : (
              <Navigate to="/organisations/dashboard" replace />
            )
          }
        />
        <Route
          path="member-organisations"
          element={
            access.canViewMemberOrganisations ? (
              <OrganisationGroupsMemberOrganisations />
            ) : (
              <Navigate to="/organisations/dashboard" replace />
            )
          }
        />
        <Route
          path="staff-detail/:id/:type"
          element={<OrganisationGroupsStaffDetail />}
        />
        <Route path="settings" element={<OrganisationGroupsSettings />} />
        <Route
          path="update-password"
          element={<OrganisationGroupsUpdatePassword />}
        />
        <Route
          path="help-support"
          element={<OrganisationGroupsHelpAndSupport />}
        />
        <Route path="faqs" element={<FAQs />} />
        <Route
          path="report-issue"
          element={<OrganisationGroupsReportAnIssue />}
        />
        <Route
          path="school-details"
          element={
            access.canViewGroupSchoolDetails ? (
              <OrganisationGroupsSchoolDetails />
            ) : (
              <Navigate to="/organisations/settings" replace />
            )
          }
        />
      </Route>
    </Routes>
  );
}
